import { Component } from '@theme/component';

/**
 * Cart Drawer Express Checkout Component
 * Manages the express checkout disclosure (details/summary) in the cart drawer.
 *
 * @extends {Component}
 */
class CartDrawerExpressCheckout extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#handleClickOutside);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#handleClickOutside);
  }

  /**
   * Closes the details when clicking outside.
   * @param {MouseEvent} event
   */
  #handleClickOutside = (event) => {
    if (!(event.target instanceof Node)) return;
    if (this.contains(event.target)) return;

    const details = this.querySelector('details');
    if (details?.open) {
      details.open = false;
    }
  };
}

if (!customElements.get('cart-drawer-express-checkout')) {
  customElements.define('cart-drawer-express-checkout', CartDrawerExpressCheckout);
}
